import { render, staticRenderFns } from "./CbsArgument.vue?vue&type=template&id=ecd7fcd8&scoped=true"
import script from "./CbsArgument.vue?vue&type=script&lang=js"
export * from "./CbsArgument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd7fcd8",
  null
  
)

export default component.exports